import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withRouterConfig } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { authInterceptor } from './interceptors/auth.interceptor';

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        // `paramsInheritanceStrategy: 'always'` so child routes that declare their OWN param
        // (e.g. `agents/:agentId`, `agents/:agentId/edit`) still inherit ancestor params like
        // `projectId` from `projects/:projectId`. Without this, the default `emptyOnly` strategy
        // leaves `projectId` empty on the detail/edit routes, producing `/projects//agents/...`
        // gateway calls that never resolve a real agent.
        provideRouter(routes, withRouterConfig({ paramsInheritanceStrategy: 'always' })),
        provideAnimations(),
        provideHttpClient(withInterceptors([authInterceptor])),
    ],
};
